export default __webpack_public_path__ + "images/WR.872d8c0.png";